module.exports = __webpack_public_path__ + "resources/img/logo_tcc_color.bbb8f1b481908d7328d5c3b54a3b3fb1.png";